module.exports = __webpack_public_path__ + "/3dc709dbfe26213699499bad4ccdcf68.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/clouds_onedrive.svg
 ** module id = 1261
 ** module chunks = 0
 **/